import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Generate from "@/pages/Generate";
import MyPairings from "@/pages/MyPairings";
import PairingDetail from "@/pages/PairingDetail";
import Community from "@/pages/Community";
import PublicPairing from "@/pages/PublicPairing";
import { ReelLoader } from "@/components/ReelLoader";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen pt-24"><ReelLoader label="Loading..." /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen pt-24"><ReelLoader label="Loading..." /></div>;
  if (user) return <Navigate to="/pairings" replace />;
  return children;
}

function AppShell() {
  const location = useLocation();
  // Detect the OAuth callback synchronously (before ProtectedRoute runs) to avoid race conditions
  const isCallback = location.hash?.includes("session_id=");

  return (
    <>
      <Navbar />
      {isCallback ? (
        <AuthCallback />
      ) : (
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/community" element={<Community />} />
          <Route path="/p/:id" element={<PublicPairing />} />
          <Route path="/login" element={<GuestOnly><Auth mode="login" /></GuestOnly>} />
          <Route path="/register" element={<GuestOnly><Auth mode="register" /></GuestOnly>} />
          <Route path="/generate" element={<Generate />} />
          <Route path="/pairings" element={<ProtectedRoute><MyPairings /></ProtectedRoute>} />
          <Route path="/pairings/:id" element={<ProtectedRoute><PairingDetail /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
      <Toaster position="top-center" theme="dark" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App grain min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
